import { render, staticRenderFns } from "./LinkReply_4_1.vue?vue&type=template&id=90b7bab0"
import script from "./LinkReply_4_1.vue?vue&type=script&lang=js"
export * from "./LinkReply_4_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports